// extracted by mini-css-extract-plugin
module.exports = {"root":"lessonDetailTab_root__SCJh0","tab":"lessonDetailTab_tab___GVxA","list":"lessonDetailTab_list__IfUgA","panel":"lessonDetailTab_panel__b4wNW"};